import HttpRepository from './httpRepository'

export default class StreamingRepository extends HttpRepository {
  async watch({ liveId }) {
    const params = new URLSearchParams()

    params.append('ua', navigator.userAgent)

    const data = await this.post(`/v1/streaming/watch/${liveId}`, params, {
      withCredentials: true
    })
    return data
  }

  // 外部サイトで視聴する配信(number_i_external_serial)の「視聴する」押下を記録する。
  // BE は通常配信の watch と同じく streaming_user_relations に entry_time / user_agent / ip を残す(初回のみ)
  watchExternal({ liveId }) {
    const params = new URLSearchParams()
    params.append('ua', navigator.userAgent)
    return this.post(`/v1/streaming/watchexternal/${liveId}`, params)
  }

  async list() {
    // Web フロントのビルド識別子(ビルド日時)をクエリで付ける。BE はこの値がないリクエストを古いビルドとみなし、
    // 古い固定文言で表示されうる配信(Number_i 67418)を一覧に含めない。
    // (CORS の許可ヘッダーが固定のためヘッダーではなくクエリパラメータで送る)
    const data = await this.get('/v1/streaming/list', {
      params: { web_build: process.env.WEB_BUILD }
    })
    return data
  }

  comment({ liveId, message }) {
    const params = new URLSearchParams()
    params.append('streaming_id', liveId)
    params.append('message', message)
    return this.post('/v1/comment', params)
  }

  deleteComment({ commentId }) {
    return this.delete(`/v1/comment/${commentId}`)
  }

  async getCommentList({ liveId, commentId, count }) {
    const messages = await this.get(`v1/comment/list/${liveId}`, {
      params: {
        comment_id: commentId,
        num: count || 100
      }
    })
    return messages.comments
  }

  async watchAdmin({ liveId }) {
    const data = await this.post(
      `/v1/streaming/watchadmin/${liveId}`,
      {},
      {
        withCredentials: true
      }
    )
    return data
  }

  commentAdmin({ liveId, message }) {
    const params = new URLSearchParams()
    params.append('streaming_id', liveId)
    params.append('message', message)
    return this.post('/v1/comment/admin', params)
  }

  changeNameSign({ code, nameSign }) {
    const params = new URLSearchParams()
    params.append('name_sign', nameSign)
    params.append('code', code)
    return this.put('/v1/streaming/userinfo', params)
  }
}
